export default "__VITE_ASSET__BbrKKr4u__"